import { MEDIA_URL } from "../constants";

export const generateMediaPath = (path, prefix = MEDIA_URL) => {
  if (!path) return "";
  const url = new URL(path, prefix);
  return url.toString();
};
